import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import {
  getPreferences,
  type UpdatePreferencesRequest,
  updatePreferences,
  type UserPreferences,
} from "../api/preferences";

/** The user's personalization preferences. Stale for 5 min — they change rarely. */
export function usePreferences() {
  return useQuery({
    queryKey: queryKeys.me.preferences(),
    queryFn: getPreferences,
    staleTime: 5 * 60_000,
  });
}

/**
 * Partial preferences update. The server returns the full updated object, which
 * we write straight into the cache so the form and any other readers re-sync
 * without a refetch.
 */
export function useUpdatePreferences() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdatePreferencesRequest) => updatePreferences(body),
    onSuccess: (updated: UserPreferences) => {
      qc.setQueryData(queryKeys.me.preferences(), updated);
    },
  });
}
